import {mapActions, mapGetters, mapMutations} from 'vuex';


export default {
    name: 'courses-main',
    data() {
        return {}
    },
    created() {
        if (!this.currentItem && !this.isLoading) this.fetchData({slug: this.$route.params.item});
    },
    components: {},
    computed: {
        ...mapGetters({
            currentItem: 'courses/currentItem',
            isLoading: 'courses/isLoading',
        })
    },
    methods: {
        ...mapActions({
            fetchData: 'courses/GET_COURSE_ITEM',
        }),
        ...mapMutations({
            setContent: `courses/SET_ITEM`
        }),
    }
}
